<template>
<div class="el-element-font">
  <el-menu center-content center
    align="left"
    v-model="tabOpen"
    >
    <!-- <el-menu-section title="Overview" /> -->

    <el-menu-item title="KPI" v-if="show.kpi">
      <key-performance-indicators />
    </el-menu-item>

    <el-menu-item title="Latest" v-if="show.latest">
      <latest-events />
    </el-menu-item>

    <el-menu-item title="Sales funnel" v-if="show.funnel">
      <sales-funnel />
    </el-menu-item>

    <el-menu-item title="Subscribers">
      <subscriber-data />
    </el-menu-item>

    <el-menu-item title="HeadQ & app">
      <overview-data />
    </el-menu-item>

    <el-menu-item title="Performance" v-if="show.performance">
      <performance-overview />
    </el-menu-item>

    <el-menu-item title="Rides" v-if="show.rides">
      <rides-overview />
    </el-menu-item>

    <el-menu-section title="Sales" />

    <el-menu-item title="Coupons">
      <coupon-codes />
    </el-menu-item>

    <el-menu-item title="Partners">
      <partner-codes />
    </el-menu-item>

    <el-menu-item title="Sales" :notification="newPurchases">
      <customer-orders />
    </el-menu-item>

    <el-menu-section title="Tech" />

    <el-menu-item title="HeadQ settings">
      <head-q-settings />
    </el-menu-item>

    <el-menu-item title="DFU">
      <head-q-firmware />
    </el-menu-item>

    <el-menu-item title="Server status">
      <server-status />
    </el-menu-item>

    <el-menu-item title="Database">
      <database-monitoring />
    </el-menu-item>

    <el-menu-item title="Test Klarna">
      <klarna-test />
    </el-menu-item>

    <el-menu-section title="" />

    <el-menu-item title="Export data">
      <export-data />
    </el-menu-item>

    <el-menu-item title="Logout">
      <button @click="logOut">Log out</button>
    </el-menu-item>
  </el-menu>
</div>
</template>
<script>

import { mapGetters } from 'vuex'
import KeyPerformanceIndicators from 'components/adminPage/KeyPerformanceIndicators.vue'
import LatestEvents from 'components/adminPage/LatestEvents.vue'
import SalesFunnel from 'components/adminPage/SalesFunnel.vue'
import OverviewData from 'components/adminPage/OverviewData.vue'
import authentication from 'services/authentication.js'
import HeadQSettings from 'components/adminPage/HeadQSettings.vue'
import CustomerOrders from 'components/adminPage/CustomerOrders.vue'
import CouponCodes from 'components/adminPage/CouponCodes.vue'
import ServerStatus from 'components/adminPage/ServerStatus.vue'
import HeadQFirmware from 'components/adminPage/HeadQFirmware.vue'
import SubscriberData from 'components/adminPage/SubscriberData.vue'
import KlarnaTest from 'components/adminPage/KlarnaTest.vue'
import PartnerCodes from 'components/adminPage/PartnerCodes.vue'
import DatabaseMonitoring from 'components/adminPage/DatabaseMonitoring.vue'
import PerformanceOverview from 'components/adminPage/PerformanceOverview.vue'
import RidesOverview from 'components/adminPage/RidesOverview.vue'
import ExportData from 'components/adminPage/ExportData.vue'

import logScope from 'log-scope'

const log = logScope('AdminPage')

export default {
  components: { SubscriberData, SalesFunnel, LatestEvents, KeyPerformanceIndicators, OverviewData, HeadQSettings, CustomerOrders, CouponCodes, ServerStatus, HeadQFirmware, KlarnaTest, PartnerCodes, DatabaseMonitoring, PerformanceOverview, RidesOverview, ExportData },
  data () {
    return {
      tabOpen: 0,
      show: {
        latest: true,
        kpi: true,
        funnel: true,
        performance: false,
        rides: true
      }
    }
  },
  computed: {
    ...mapGetters([
      'newPurchases'
    ])
  },
  watch: {
    tabOpen () {
      localStorage.setItem('rideQAdminPageTabOpen', this.tabOpen)
    }
  },
  mounted () {
    const index = localStorage.getItem('rideQAdminPageTabOpen')

    if (index) {
      this.tabOpen = Number(index)
    }
  },
  methods: {
    logOut () {
      authentication.signOut()
        .then(() => {
          this.$router.replace('login')
          log.debug('Logoug')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
